import React, {Component} from 'react';
import {Redirect} from 'react-router-dom';
import {PostData} from '../../services/PostData';
import {GetData} from '../../services/GetData';
import {
  Row,
  Col,
  Button,
  ButtonDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Card,
  CardHeader,
  CardFooter,
  CardBody,
  Collapse,
  Form,
  FormGroup,
  FormText,
  Label,
  Input,
  InputGroup,
  InputGroupAddon,
  InputGroupText,
  Table
} from 'reactstrap';

class EditPaymentType extends Component {
	
	/** set property value **/
	constructor(props){
		super(props);
		this.state = {
			id : '',
			paytype : '',
			_message : '',
			alertClass :'',
			_redirect : false
		}
		this.onChange = this.onChange.bind(this);
		this.onSubmit = this.onSubmit.bind(this);
		this.onBack = this.onBack.bind(this);
	}
	
	onBack(e){
		
		this.setState({_redirect : true});
	}
	
	/** set value **/
	onChange(e){
		this.setState({[e.target.name]:e.target.value});
		console.log(this.state);
	}
	
	/** submit form **/
	onSubmit(e){
		e.preventDefault();
		
		if(this.state.paytype){
			
			PostData('payroll/updatepaytype',this.state).then((result) => {
				let responseJson = result;
				if(responseJson.status == '1' ){
					this.setState({
						_message:'Payment Type Updated Successfully!..',
						alertClass:'alert alert-success',
					});
					document.getElementById("paytype").reset();
				}
				else{
			
					this.setState({
						_message:'Invalid Key',
						alertClass:'alert alert-danger'
					});
				}
			});
		
		}
	
	}
	
	/** this function will be call when page loading **/
	componentWillMount(){
		
		this.getdetails();
	}
	
	/** get Class **/
	getdetails(){
		
		GetData('payroll/getpaytypebyid/'+this.props.match.params.id).then((result) => {
			let res = result;
			if(res){
				this.setState({
					paytype : res[0]['paytype']
				});
			}
		});
	}
	
  render() {
	
	this.state.id = this.props.match.params.id;
	
	if(this.state._redirect){
		  
		return (<Redirect to='/payroll/paytype' />);
	}
	
    return (
		<div className="animated fadeIn">
			<div className={this.state.alertClass}>
				{this.state._message}
			</div>
			<Row>
			  <Col md="6">
				<Card>
				  <form action="" method="post" role="form" id="paytype" encType="multipart/form-data" onSubmit={this.onSubmit} >
					<CardHeader>
						<strong>Edit Payment Type</strong>
						<span className="pull-right">
							<Button outline color="primary" onClick={this.onBack}>Back</Button>
						</span>
					</CardHeader>
					<CardBody>
						<Row>
						  <Col md="12">
							<FormGroup>
							  <Label htmlFor="name">Payable Type Name <span className="text-danger">*</span></Label>
							  <Input type="text" name="paytype" required onChange={this.onChange} value={this.state.paytype}  />
							</FormGroup>
						  </Col>
						</Row>
					</CardBody>
					<CardFooter>
						<Button type="submit" size="sm" color="primary"><i className="fa fa-dot-circle-o"></i> Update</Button>
					</CardFooter>
				  </form>
				</Card>
			  </Col>
			</Row>
		</div>
	)
  }
}

export default EditPaymentType;


// WEBPACK FOOTER //
// ./src/payroll/PaymentType/EditPaymentType.js